import { Routes } from '@angular/router';
import { chatConversationRoutes } from './chat-conversation/chat-conversation.routes';

export const chatRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./chat.page').then((m) => m.ChatPage),
  },
  {
    path: 'chat-conversation',
    children: chatConversationRoutes,
  },
];
